(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('progressBar', function () {
			return {
				replace: true,
				templateUrl: baseUrl + 'root/app/views/progress-bar.tpl.html',
				restrict: 'E',
				scope: {
					steps: "=",
					current: "=",
					mobsteps: "=",
					mobcurrent: "="
				},
				link: function (scope, elem, attrs) {
					scope.$watch('current', function (value) {
						scope.position = Math.round((scope.current / scope.steps) * 100);
						if (scope.position > 100) scope.position = 100;
					});

					scope.$watch('mobcurrent', function (value) {
						scope.mobposition = Math.round((scope.mobcurrent / scope.mobsteps) * 100);
						if (scope.mobposition > 100) scope.mobposition = 100;
					});

				}
			}
		});

})();
